import React, {useState} from 'react';
import classnames from 'classnames';
import {RenderOnlyFor, PrintButton, ShareViaEmailModal, ShareViaSmsModal, NeuroMessage, useNeuroState} from '@ignitesales/neuro-application';
import PropTypes from 'prop-types';
import BranchMenu from "@ignitesales/neuro-application/src/neuro-guide/components/BranchMenu";
import ReactSVG from 'react-svg';
import { getBankSaved } from '../utils/getBank.js';
import {useBreakpoints} from "@ignitesales/neuro-application/src/neuro-ui/index.mjs";


const Header = ({className, children}) => {
    const componentClass = 'header';
    const classes = classnames(
        'header',
        className
    );
    const { md } = useBreakpoints();
    const isMobile = !md;
    const [showTextMsg, setShowTextMsg] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const { answers, bankSelected } = useNeuroState();
    const bankTheme = getBankSaved(bankSelected, answers.urlParameters);
    const currentUrl = window.location.href;
    const isDetailsPage = currentUrl.includes('details');
  
    const logoFile = isMobile ? 'central-logo-mobile.svg' :  'central-logo.svg';

    return <header className={classes}>
        <div className='headerContainer'>
            <div className={`${componentClass}__logo ${bankTheme}__logo`}>
                <ReactSVG src={ bankTheme === "centralbank" ? `/classpath/assets/images/${logoFile}` : bankTheme === 'jefferson' ? '/classpath/assets/images/new-bank-jefferson.svg' : '/classpath/assets/images/new-bank-central.svg'}/>
            </div>
            <RenderOnlyFor forSummaryPage={true} forDetailsPage={true}>
                <div className={`actionsHeaderContainer ${bankTheme}`}>
                    <RenderOnlyFor forSummaryPage={true}>
                        <NeuroMessage id="header.results" tagName="span" />
                    </RenderOnlyFor>
                    <button className={`${componentClass}__button`} onClick={() => setShowTextMsg(true)}>
                        <i className="fa fa-mobile" /> 
                    </button> 
                    <button className={`${componentClass}__button`} onClick={() => setShowEmail(true)}>
                        <i className="fa fa-envelope" /> 
                    </button> 
                    <PrintButton className={`${componentClass}__button`} shouldOpenDetailsPage={!isDetailsPage}>
                        <i className="fa fa-print" /> 
                    </PrintButton> 
                </div>
            </RenderOnlyFor>
            <BranchMenu />
        </div>
        <ShareViaSmsModal isOpen={showTextMsg} className={`${bankTheme}`} closeBtn={ <i className="fa fa-close"/> } onClose={() => setShowTextMsg(false)} /> 
        <ShareViaEmailModal isOpen={showEmail} className={`${bankTheme}`} closeBtn={ <i className="fa fa-close"/> } onClose={() => setShowEmail(false)} /> 
        {children}
    </header>;
};

Header.propTypes = {
    className: PropTypes.string
};

export default Header;
